import React, { forwardRef, useCallback, useState } from 'react'

import { Autocomplete } from '@/components/ui/Autocomplete'
import { useArticles } from '@/hooks/useArticles'

interface ArticleInputAutocompleteProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  variant?: any;
  size?: any;
  isInvalid?: boolean;
  errorMessage?: string;
  className?: string;
  onBlur?: React.FocusEventHandler;
  onFocus?: React.FocusEventHandler;
  name?: string;
  label?: string;
  required?: boolean;
}

export const ArticleInputAutocomplete = forwardRef<HTMLInputElement, ArticleInputAutocompleteProps>((props, ref) => {
  const { value, onBlur, onFocus } = props
  const [isFocused, setIsFocused] = useState(false)
  const { data: suggestions, isLoading } = useArticles(value, isFocused)

  const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true)
    onFocus?.(e)
  }, [onFocus])

  const handleBlur = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false)
    onBlur?.(e)
  }, [onBlur])

  return (
    <Autocomplete
      {...props}
      ref={ref}
      suggestions={suggestions}
      isLoading={isLoading}
      onFocus={handleFocus}
      onBlur={handleBlur}
      menuTrigger="focus"
    />
  )
})

ArticleInputAutocomplete.displayName = 'ArticleInputAutocomplete'
